import { CustomerCardPersonalFormType } from "@/components/features/ToDos/CustomerCardPage/steps/DetailsStep/formType";

export enum CommunicationType {
    NONE = "none",
    PAPER = "paper",
    EMAIL = "email",
}

export type CustomerCardCommunicationFormType = Omit<MyBrokerApi.OfficeCommunication, "date"> & {
    date?: Date;
};

export const customerCardCommunicationDefaultValues = (
    currentDetails: MyBrokerApi.PersonalDetails = null,
): CustomerCardCommunicationFormType => {
    return {
        representativeInfo: "",
        address: "",
        date: new Date(),
        channel: currentDetails.communicationChannel ?? CommunicationType.NONE,
    };
};

export const getSignAddress = (personal: CustomerCardPersonalFormType): string => {
    return [
        personal?.street,
        personal?.houseNumber,
        personal?.boxNumber,
        personal?.zipCode,
        personal?.city,
        personal?.additionalInfo,
    ]
        .filter(Boolean)
        .join(", ");
};
